var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.topBar},[_c('div',{class:_vm.$style.bannerBox,on:{"click":_vm.toHome}},[_c('i',{class:_vm.$style.bannerLogoIcon}),_c('span',[_vm._v(_vm._s(_vm.$t("447ee65591")))])])])}
var staticRenderFns = []

export { render, staticRenderFns }